export const SESSION_API_PREFIX = '/api/session';
